
    import Vue from 'vue';
    import axios from 'axios';
    import { i18n } from '@/main'; '@/main.js';
    // Import Vue FilePond
import vueFilePond from "vue-filepond";

// Import FilePond styles
import "filepond/dist/filepond.min.css";
// @ts-ignore
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js";
// @ts-ignore
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size/dist/filepond-plugin-file-validate-size.esm.js';

// Create component
// @ts-ignore
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginFileValidateSize);
       export default Vue.extend({
        
          name: 'App',
          
          
          data: function() {
            return {
              show: false,
              submitSuccess:false,
              stateControlArr:{},
              intakeForm: {} as any,
              questions:{
    
              } as any,
              intakeFormDTO:{
                consentSignature:'',
                consentSignature2:'',
                consentSignature3:'',
                consentFullName:'',
              } as any,
              branchingOptions:[],
              isLoading:false,
              activeBranchingQuestions:[],
              questionCounter:0,
              sliceCounter:0,
              languageLocalizations:[],
              languageSelected:'',
              dropdownSelectedValues:{},
              isFirstLoading:true,
              signatureEmpty:null,
              validationIdConsentFullName:'vidCFN1',
              showSubmitErrorMessageFirstTime:false,
              groupDynamicFieldCounter:{},
              groupHeaderDynamicFieldCounter:{} as any,
              questionOptions:{},
              questionFormulas:[],
              questionFormulaIDCache:{},
             
            }
          },
         components: {
          FilePond,
          },
          created: function() {
           
          
           const { orgName, subOrgName } = this.$route.params;

           if(!orgName || !subOrgName){
                return;
           }
           let url = location.href;
           this.show = true;
          
              axios.get(process.env.VUE_APP_OnlineIntakeWebApiUrl + '/api/dynamiconlineintake/form',{params:{companyName:url}})
                 .then(resp => {
                    this.intakeForm = resp.data;
                    this.intakeForm.HelpTextLocalizations = [];
                  this.questionFormulas = resp.data.QuestionFormulas;
                  this.Title = this.intakeForm.IntakeForm.Title;

                 if(resp.data.IntakeForm.DirectionRightToLeft !== undefined && resp.data.IntakeForm.DirectionRightToLeft != null){
                  this.setDirection(resp.data.IntakeForm.DirectionRightToLeft);

                 }
                 
                  if(resp.data.Localizations || resp.data.GeneralLocalizations){
                    this.loadLanguageAsync(resp.data.Localizations, resp.data.GeneralLocalizations, resp.data.IntakeForm.Language);
                    
                  }
                    this.show = false;
                     
                      this.intakeForm.QuestionGroup.forEach((qGroup:any) => {
                      
                      qGroup.overrideColumnDivider = qGroup.Questions.length > 0 && qGroup.Questions[0].OverrideColumnDivider > 0? qGroup.Questions[0].OverrideColumnDivider : 2;


                      this.groupHeaderDynamicFieldCounter[qGroup.Name] = qGroup.BranchingOptionsDynamics?.length > 1 ?  1 : qGroup.overrideColumnDivider;
                        
                      qGroup.Questions.forEach((question:any) => {
                          this.questionCounter++;
                          if(question.BranchingOptions.length > 0){
                            let branchingOption = {} as any;
                            branchingOption[question.ID] = [];
                            question.BranchingOptions.forEach((el:any) => {
                                branchingOption[question.ID].push(el);
                             
                              
                            });
    
                            this.branchingOptions.push(branchingOption);
                          }
                         
                            if(question.ControlType === 'Dropdown' || question.ControlType === 'MultiCheckbox'){
                            
                            var controlValues = question.ControlValue.split('|');
                            var currentValueIndex = controlValues.indexOf(question.DefaultControlValue);

                            let defaultControlValueSelect:any = question.DefaultControlValue ?  question.DefaultControlValue + '|' + question.ID + '|' + currentValueIndex: null;
    
                            if(question.ControlType === 'MultiCheckbox' && defaultControlValueSelect === null){
                              defaultControlValueSelect = [];
                            }
                           
                            Vue.set(this.questions, question.Caption.trim().replace(/\s/g, '-').replace(':','') + '+' + qGroup.Name + '-' + qGroup.SubTitle + '+' + question.ControlID, defaultControlValueSelect)
                           
                          }
                         
                          else{
                            let defaultControlValue = question.DefaultControlValue ? question.DefaultControlValue : '';
                            
                            if(question.ControlType !== 'FileUpload'){
                                Vue.set(this.questions, question.Caption.trim().replace(/\s/g, '-').replace(':','') + '+' + qGroup.Name + '-' + qGroup.SubTitle + '+' + question.ControlID, defaultControlValue)
                            }else{
                                Vue.set(this.questions, question.Caption.trim().replace(/\s/g, '-').replace(':','') + '+' + qGroup.Name + '-' + qGroup.SubTitle + '+' + question.ControlID + '|' + question.ID, defaultControlValue)
                        
                            }
                          }
    
                         
                          
                         
                         
                      })

                    })
                    this.questionCounter = Math.ceil(this.questionCounter / 2);

                    
                  })

          },
          mounted:function(){
           window.addEventListener("beforeunload", this.handleBeforeUnload);
           
          },
          updated:function(){
          
            this.hideBranchingQuestions();
            this.hideGroupSubGroupQuestions();
            this.isFirstLoading=false;
          
          },
          watch:{
            sliceCounter(newVal){
              console.log(newVal);
            },
            '$i18n.locale': function() {

            }
          },
          computed:{
           inputState(){

            return(model:any, controlMask:any, controlID:any)=>{
                var isLengthSamewithControMask = model?.length == controlMask?.length;

                if(controlMask){
                 
                  if(!(controlID in this.stateControlArr)){
                     this.stateControlArr[controlID] = false;
                  }
                  if(!isLengthSamewithControMask){
                    this.stateControlArr[controlID] = false;
                  }else{
                    this.stateControlArr[controlID] = true;

                  }
                  
                  if(model?.length == 0) return null;
                  return isLengthSamewithControMask;
                }

                return null;
              }
            }
               
          },
          methods:{
             handleBeforeUnload(event:any) {
             
              event.preventDefault();
    
            },
            submitClick(){

              
              this.showSubmitErrorMessageFirstTime = true;
             this.$refs.form.validate().then((isValid:any) => {
               
                 
                   if(!isValid){
                    setTimeout(() => {
                    
                      var errorFields = this.$el.querySelectorAll('.error')
                      for(var error of errorFields){
                      
                        if(error.innerText !== '' && error.innerText !== undefined){
                            error.previousElementSibling.focus();
                           
                            return;
                        }
                      }
                     
                    
                        //this.$el.querySelector('[id="' + second + '"]').scrollIntoView(false);
                       
                    }, 100);
                   }
                 
                  
              });
             
            },
            onFormSubmit(){
             

              this.setAllSignatureOnSubmits();

              var isControlMaskFalse = Object.keys(this.stateControlArr).filter(x => this.stateControlArr[x] === false);
            
              if(isControlMaskFalse.length > 0){
                return;
              }
              if(this.signatureEmpty && this.intakeForm?.IntakeForm?.ShowConsentFullName){
                
                return;
              }
           
         
              const questionsAnwsers = Object.assign({}, this.questions);
             

              let fileUploadObj:any = [];
              this.setAllUploadFilesControl(null, fileUploadObj, questionsAnwsers);

              for(var q in questionsAnwsers){
 
               
              
                if(Array.isArray(questionsAnwsers[q])){
 
                    let tempQuestionsAnswer = questionsAnwsers[q];
                    
                    questionsAnwsers[q] = '';
                    
   
                    tempQuestionsAnswer.forEach((question:any) => {

                
                      if(typeof question === 'object'){
                        var { value }  = question;
                      
                        question = value;
                      }
               
                    
                      if(question !== undefined && question.toString().indexOf('|') >= 0){
                        
                        let questionAnswersSplit = question.toString().split('|');
                     
                        questionsAnwsers[q] += questionAnswersSplit[0] + ',';
                      
                         
                      }else{
                        questionsAnwsers[q] = questionsAnwsers[q].toString();
                   
                      }
                    })
  
                    questionsAnwsers[q] = questionsAnwsers[q].lastIndexOf(',') >= 0 ? questionsAnwsers[q].slice(0, -1) : questionsAnwsers[q];
                    
                  
                }

              
                if(typeof questionsAnwsers[q] === 'object' && questionsAnwsers[q] !== undefined){

                 
                  questionsAnwsers[q] = questionsAnwsers[q]?.value;
                
                 
                }
                

             
                  let value = questionsAnwsers[q] ? questionsAnwsers[q].toString() : null;
              
                  if(value && value.indexOf('|') > 0){
                    value = value.split('|')[0];
                   
                    questionsAnwsers[q] = value;
                  }
              }

               
              const languageSelectedCode = this.languageSelected && this.languageSelected.split('-').length > 0 ? this.languageSelected.split('-')[0] : null;
              const submitOnlineIntakeDTO = {
                intakeFormDTO:this.intakeFormDTO,
                intakeForm:this.intakeForm.IntakeForm,
                localizationSelected:languageSelectedCode,
                questionsAnwsers,
              }
              this.show = true;
             
              axios.post(process.env.VUE_APP_OnlineIntakeWebApiUrl + '/api/dynamiconlineintake/form', submitOnlineIntakeDTO)
                .then(resp => {
                  
                  const result = resp.data;
                  
                  if(result.Success){
                   
                  
                    if(fileUploadObj.length > 0 || this.intakeForm?.IntakeForm?.IsImportOnlineIntaketoAPI){
                         const formData = new FormData();
                       
                         formData.append('SubmittedIntakeFormID', result.SubmittedIntakeFormID);
                       
                         var singleCounter = 0;
                         fileUploadObj.forEach((e:any) => {
                       
                          if(Array.isArray(e.file)){
                                e.file.forEach((f:any, index:any) => {
                              formData.append(e.questionId + '|' + index.toString(), f);
                          })
                          }else{
                            formData.append(e.questionId + '|' + singleCounter++, e.file);
                          }
                          
                          
                         })
                        
                         axios.post(process.env.VUE_APP_OnlineIntakeWebApiUrl + '/api/dynamiconlineintake/fileupload', formData, {
                              headers: {
                                  'Content-Type': 'multipart/form-data',
                              },
                              
                         })
                          .then(resp => {
                              if(resp.data){
                                  this.show = false;
                                  this.submitSuccess = true;
                              }
                          })

                      //    this.show = false;
                      // this.submitSuccess = true;
                    }else{
                      this.show = false;
                      this.submitSuccess = true;
                    }

                  window.removeEventListener("beforeunload", this.handleBeforeUnload);
                  }
                })
              
              
            },
            saveSignature(event:any){
              event.preventDefault();
              const { data } = this.$refs.signaturePad.saveSignature();
               
              if(data){
                this.intakeFormDTO.consentSignature = data;
              }
             
              if(this.$refs.signaturePad2.saveSignature().data){
                this.intakeFormDTO.consentSignature2 = this.$refs.signaturePad2.saveSignature().data;
              }

              if(this.$refs.signaturePad3.saveSignature().data){
                this.intakeFormDTO.consentSignature3 = this.$refs.signaturePad3.saveSignature().data;
              }

    
            },
              clearSignature(signaturePadSection:any){

              if(signaturePadSection === '1'){
                this.$refs.signaturePad.clearSignature();
              }

              if(signaturePadSection === '2'){
                this.$refs.signaturePad2.clearSignature();
              }

              if(signaturePadSection === '3'){
                this.$refs.signaturePad3.clearSignature();
              }
            },
            setAllSignatureOnSubmits(){
            
               if(this.$refs.signaturePad?.saveSignature().data){
                 this.intakeFormDTO.consentSignature = this.$refs.signaturePad.saveSignature().data;
                 this.signatureEmpty = false;
               }else{
                this.signatureEmpty = true;
               
                 return;
               }
 
               if(this.$refs.signaturePad2?.saveSignature().data){
                 this.intakeFormDTO.consentSignature2 = this.$refs.signaturePad2.saveSignature().data;
               }
 
               if(this.$refs.signaturePad3?.saveSignature().data){
                 this.intakeFormDTO.consentSignature3 = this.$refs.signaturePad3.saveSignature().data;
               }
            },
            resetBranchingQuestions(questionID:any){
              
              this.$refs.questionRefs.forEach((el:any) => {
                let elementID = el.children[1].firstElementChild.id;
                
             
                //for single checkbox question, the element structure is different
                if(el.children[1]?.children[0]?.firstElementChild?.children[0] !== undefined){
                  elementID = el.children[1].children[0].firstElementChild.children[0].id;
                }

                if(elementID.indexOf('_BV_option_0') >= 0){
                      elementID = elementID.replace('_BV_option_0','');
                    }

                //this.setIsRequired(elementID, false);
                // if(el.children[1].firstElementChild.hasAttribute('data-required')){
                //     this.$refs.validationProvider.forEach((v:any) => {
                     
                //        if(v.vid == elementID){
                       
                //          v.disabled = true;
                //        }
                //     })
                //     }

                const [branchingOptionFirst] = this.intakeForm.BranchingOptions.filter((x:any) => x.QuestionID === questionID);
                const [branchingOption] = this.intakeForm.BranchingOptions.filter((x:any) => x.NextQuestionID === elementID && x.QuestionGroup === branchingOptionFirst.QuestionGroup && x.NextQuestionID !== questionID);

                
                
                if(branchingOption)
                {
                 
                  el.style =  'display:none';
                  this.setIsRequired(elementID, false);
                 
                }
              })
             
            },
          
            hideBranchingQuestions(){
            
              if(!this.isLoading){
                 
                  if(this.$refs.questionRefs){
                   
                    this.$refs.questionRefs.forEach((el:any) =>{ 
                 
                  let elementID = el.children[1].firstElementChild.id;
                  
                    //for single checkbox question, the element structure is different
                if(el.children[1]?.children[0]?.firstElementChild?.children[0] !== undefined){
                  elementID = el.children[1].children[0].firstElementChild.children[0].id;
                }

                 
                   if(elementID){
                      if(elementID.indexOf('_BV_option_0') >= 0){
                        elementID = elementID.replace('_BV_option_0','');
                        
                      }    
                      for (const [ , value] of Object.entries(this.intakeForm.BranchingOptions)) {
                        const branchingOption = value as any;
                       
                          if(branchingOption.NextQuestionID == elementID && !branchingOption.IsHideWhenAnswerCorrect){
                         
                            el.style = 'display:none'
                            if(el.children[1].firstElementChild.hasAttribute('data-required') || el.children[1].firstElementChild.hasAttribute('is-required-temp')){
                       
                              //el.children[1].firstElementChild.removeAttribute('required');
                            
                              this.setIsRequired(elementID, false);
                             
                              if(this.isFirstLoading){
                                el.children[1].firstElementChild.setAttribute('is-required-temp', true);
                  
                              }

                             }

                           
                          }
                          
                        }
    
                        
    
                    }
    
                this.isLoading = true;
              })
                  }
                  
              }
            },
            displayBranchingQuestions(questionID:any, dropDownValue:any, questionCaption:any){
              
              var originalAnswerBranchingFields =  this.getOriginalAnswerforBranchingFields(dropDownValue, questionCaption);
              if(originalAnswerBranchingFields && originalAnswerBranchingFields !== undefined){
                dropDownValue = originalAnswerBranchingFields
              }
              const branchingOptionFound = this.intakeForm.BranchingOptions.filter((x:any) => x.QuestionID === questionID && x.Answer === dropDownValue);
             
              if(branchingOptionFound.length > 0){

                // questionID has active branching — ensure it is visible in the DOM
                this.$refs.questionRefs.forEach((el:any) => {
                  let selfID = el.children[1].firstElementChild.id;
                  if(el.children[1]?.children[0]?.firstElementChild?.children[0] !== undefined){
                    selfID = el.children[1].children[0].firstElementChild.children[0].id;
                  }
                  if(selfID.indexOf('_BV_option_0') >= 0){
                    selfID = selfID.replace('_BV_option_0','');
                  }
                  if(selfID === questionID && el.style.cssText.includes('display: none')){
                    el.style = '';
                  }
                });

                this.$refs.questionRefs.forEach((el:any) =>{
                    let elementID = el.children[1].firstElementChild.id;

                    //for single checkbox question, the element structure is different
                    if(el.children[1]?.children[0]?.firstElementChild?.children[0] !== undefined){
                      elementID = el.children[1].children[0].firstElementChild.children[0].id;
                    }

                    if(elementID.indexOf('_BV_option_0') >= 0){
                      elementID = elementID.replace('_BV_option_0','');
                    }
                    branchingOptionFound.forEach((bo:any) => {

                      if(elementID && bo.NextQuestionID === elementID){

                        el.style = bo.IsHideWhenAnswerCorrect? 'display:none' : '';

                        //this.setIsRequired(elementID, true);

                        if(el.children[1].firstElementChild.hasAttribute('is-required-temp')){
                          var isRequired = el.children[1].firstElementChild.getAttribute('is-required-temp')

                          if(isRequired){
                            this.setIsRequired(elementID, true);
                          }
                        }

                        if(!bo.IsHideWhenAnswerCorrect && this.dropdownSelectedValues[elementID]){
                          this.displayBranchingQuestions(elementID, this.dropdownSelectedValues[elementID], questionCaption);
                        }


                    }

                    })
                })
           }

           if(branchingOptionFound.length == 0 ){
            const currentBranchingOptions = this.intakeForm.BranchingOptions.filter((x:any) => x.QuestionID === questionID || x.Answer === originalAnswerBranchingFields);
            
            this.$refs.questionRefs.forEach((el:any) =>{ 
                    let elementID = el.children[1].firstElementChild.id;
                  
                    //for single checkbox question, the element structure is different
                    if(el.children[1]?.children[0]?.firstElementChild?.children[0] !== undefined){
                      elementID = el.children[1].children[0].firstElementChild.children[0].id;
                    }
                    currentBranchingOptions.forEach((bo:any) => {
                       
                      if(elementID && bo.NextQuestionID === elementID && bo.IsHideWhenAnswerCorrect){
                       
                        el.style = '';
                        
                        
                    }
                    
                    })
                })
          }
    
          //const [branchingOptionSelected] = this.intakeForm.BranchingOptions.filter((x:any) => x.NextQuestionID == questionID);
          
    
          // if(branchingOptionSelected){
          //   const branchingOptionsAnswer = this.intakeForm.BranchingOptions.filter((x:any) => x.Answer == branchingOptionSelected.Answer);
          
          //    console.log('branchingOptionsAnswer',branchingOptionsAnswer);
          
          // if(branchingOptionsAnswer.length > 0){
          //   this.$refs.questionRefs.forEach((el:any) =>{ 
          //           const elementID = el.children[1].firstElementChild.id;
                    
          //           branchingOptionsAnswer.forEach((bo:any) => {
          //             if(elementID == bo.NextQuestionID){
                       
          //             el.style = '';
          //             this.setIsRequired(elementID, true);
          //             if(el.children[1].firstElementChild.hasAttribute('data-required')){
          //               el.children[1].firstElementChild.setAttribute('required', true);
          //             }
          //           }
          //           })
                    
          //       })
          //  }
          // }
         
           
            },
            checkIfAnswerIncludedInBranchingOptions(questionId:any){
              const [branchingOption] = this.intakeForm.BranchingOptions.filter((x:any) => x.QuestionID === questionId);
               
                return branchingOption !== undefined || branchingOption != null;
            },
            getOriginalAnswerforBranchingFields(value:any, questionCaption:any){
             let localizationKey = '';
             Object.keys(this.intakeForm.Localizations).forEach((l:any) => {
                  if(l !== '$id' &&  l === this.languageSelected){
                    const currentLocalizationData = this.intakeForm.Localizations[this.languageSelected];
                  
                    if(currentLocalizationData){
                      Object.keys(currentLocalizationData).forEach((ld:any) => {
                        if(currentLocalizationData[ld].split('-').pop() === questionCaption){
                            
                          localizationKey = value;
                        }
                      })
                    }
                  }
             });

             if(localizationKey !== ''){
              return localizationKey;
             }
           },
            dropdownChanged(value:any, question:any, questionGroup:any){

              if(value == null) return;
              const [dropDownValue, questionID] = value.indexOf('|') >= 0 ? value.split('|') : [];
              //const OriginalAnswerTriggerBranchingFields = this.getOriginalAnswerforBranchingFields(dropDownValue, question.Caption);
            
              if(this.dropdownSelectedValues[questionID] != ''){
                this.dropdownSelectedValues[questionID] = dropDownValue;
              }

              if(this.checkIfAnswerIncludedInBranchingOptions(questionID)){
                this.resetBranchingQuestions(questionID);

               
                Object.keys(this.dropdownSelectedValues).forEach((ddl:any) => {
                 
                  this.displayBranchingQuestions(ddl, this.dropdownSelectedValues[ddl], question.Caption);
                  this.hideGroupSubGroupQuestions();
                })
              }
             
              this.calculateFieldFormula(value, question, questionGroup);
            },
            populateDropdown(question:any, isBootstrapSelect:any){

              let array = question.UseDropdownStyle ? [] : [{value:null, label:'Select', text:'Select', disabled:true}]
              
              if(question.ControlType === 'MultiCheckbox'){
                array = [];
              }

              let questionArr = question.ControlValue.split('|').map((val:any, index:any) => 
                ({
                  value: val.indexOf('<>') >= 0 ? val.split('<>')[1] + '<>' +  val.split('<>')[2] :  this?.intakeForm?.IntakeForm?.ShowLocalization ? 
                    this.$t(question.Caption + '-' + val) + '|' + question.ID + '|' + index 
                    : val + '|' + question.ID + '|' + index,
                  text : this?.intakeForm?.IntakeForm?.ShowLocalization ? this.$t(question.Caption + '-' + (val.indexOf('<>') >= 0 ? val.split('<>')[0]: val)) : (val.indexOf('<>') >= 0 ? val.split('<>')[0]: val),
                  label: this?.intakeForm?.IntakeForm?.ShowLocalization ? this.$t(question.Caption + '-' + val) : val
                  })
                );
              
             
              questionArr.forEach((el:any) => {
               
                array.push(el);
              })
              

              if(!isBootstrapSelect){
              if(this.questionOptions[question.ID] === undefined){
                this.questionOptions[question.ID] = array;
              }else{
                if(!this?.intakeForm?.IntakeForm?.ShowLocalization)
                array = this.questionOptions[question.ID];
              }
              }
              

           
              return array;
            },
            fileUploadChanged(value:any){
              console.log(value);
            },
            getBootstrapSizing(size:any){
              let bootstrapSize = 'sm';
              switch(true){
                case size == 25 :
                  bootstrapSize = 'sm';
                  break;
                case size == 50 :
                  bootstrapSize = 'md';
                  break;
                case size == 100 :
                  bootstrapSize = 'lg';
                  break;
              }
    
              return bootstrapSize;
            },
            setIsRequired(elementID:any, isRequired:any){
             
              this.intakeForm.QuestionGroup.forEach((qGroup:any, qGroupIndex:any) => {
                  const currentQuestion = qGroup.Questions.filter((x:any) => x.ID === elementID);
                  
                  if(currentQuestion.length > 0){
                    
                        Vue.set(this.intakeForm.QuestionGroup[qGroupIndex].Questions.filter((x:any) => x.ID === currentQuestion[0].ID)[0], 'isRequired', isRequired)
                         
                      }
                               
              })
            },
            onLanguageLocalizationsChange(lang:any){
                i18n.locale = lang;
                axios.defaults.headers.common['Accept-Language'] = lang;
                //document.querySelector('html').setAttribute('lang', lang);

          
                Object.keys(this.questions).forEach((key:any) => {
                  if(this.questions[key]){
                    const currentQuestion = this.questions[key];
                   
                    if(Array.isArray(currentQuestion)){
                      
                      Vue.set(this.questions, key, []);
                      
                    }else{
                      Vue.set(this.questions, key, '');
                    }
                  }
                })
                this.setDirection(this.intakeForm.IntakeForm.DirectionRightToLeft);
                return lang;
            },
           
            loadLanguageAsync(localizationObject:any, generalLocalizations:any, defaultLanguage:any){

              this.languageLocalizations.push({value:null, text:'Select Language', disabled:true});
             
              if(Object.keys(localizationObject).length === 1){
                localizationObject = generalLocalizations;
              }

              var defaultLanguageValue = '';
              Object.keys(localizationObject).forEach((val) => {
                if(val === '$id') return;
                
               
                    var obj = Object.assign({},generalLocalizations[val],localizationObject[val]);
                   localizationObject[val] = obj;

                    var localization = val.split('-');
                 
                    if(localization.length > 2){
                       if(defaultLanguage === localization[2]){
                        defaultLanguageValue = val;
                       }
                    }else{
                      if(defaultLanguage === localization[1]){
                        defaultLanguageValue = val;
                       }
                    }
                    this.setLocalizationDropdownValue(localization,val, localizationObject);
               

               })

                if(this.languageLocalizations.length > 1){
                 
                    i18n.locale = defaultLanguageValue !== '' ? defaultLanguageValue : this.languageLocalizations[1].value;
                    this.languageSelected = defaultLanguageValue !== '' ? defaultLanguageValue : this.languageLocalizations[1].value;
                   
                }

               
            },
            setDirection(isRightToLeft:any){
              if(isRightToLeft && i18n.locale == 'ar-Arabic'){
                document.documentElement.setAttribute('dir', 'rtl')
              }else{
                document.documentElement.setAttribute('dir', '')
              }
            },
            hideGroupSubGroupQuestions(){
              
          
              let counter = 0;
              let groupHeader = '';

              this.$refs.questionRefs.forEach((el:any) =>{ 
                
                const cssText = el.style.cssText;
                const elementID = el.children[1].firstElementChild.id;
                const [branchingOption] = this.intakeForm.BranchingOptions.filter((x:any) => x.NextQuestionID == elementID);
                const branchingOptionString = JSON.stringify(branchingOption);
                if(groupHeader != el.parentElement.parentElement.parentElement){
                  groupHeader = el.parentElement.parentElement.parentElement;
                  counter = 0;
                }
                if(branchingOptionString && cssText == 'display: none;'){
                  counter++;
                 
                  if(counter == branchingOption.TotalQuestionsInGroup){
                    
                    let parentGroup = el.parentElement.parentElement.parentElement;
                    parentGroup.style='display:none';
                    
                    counter = 0;
                  }
                }else{
                  let parentGroup = el.parentElement.parentElement.parentElement;
                  parentGroup.style='';
                }
              })
            },
            setAllUploadFilesControl(q:any, fileUploadObj:any){
              
                  // let questionControlIDArr = q.split('+');
                
                  // let questionId = '';

                  
                  // if(questionControlIDArr.length > 2){
                     
                  //       questionId = questionControlIDArr[2].split('|')[2];
                      
                  // }
                  
                 
                    // this.$refs.questionRefs.forEach((el:any) => {
                     
                    //   const element = el.children[1].children[0].children[0];
                    //   if(element){
                    //       const fileType = element.getAttribute('type');
                    //       const elId = element.getAttribute('id');
                       
                    //      if(fileType == 'file' && elId == questionId){
                    //           fileUploadObj.push({questionId: elId, file:questionsAnwsers[q]});
                    //      }
                    //   }
                    // })

                 
                    var files = this.$refs.filesRef;
                       
                    if(files === undefined) return;
                    files.forEach((f:any)=> {
                     
                      //var filesSelected = Object.keys(f.getFiles().length).length > 0 ? f.getFiles()[1] : f.getFiles()[0];
                      var input = f.$el.children[0];
                    
                 
                      if(input){
                        
                         const elId = input.attributes.id.value;
                        
                     
                  
                      Object.keys(f.getFiles()).forEach((key:any) =>{
                       
                        fileUploadObj.push({questionId:elId, file:f.getFiles()[key]?.file});
                        //  if(!fileUploadObj.some((f:any) => f.questionId == elId)){
                            
                        //     fileUploadObj.push({questionId:elId, file:f.getFiles()[key]?.file});
                            
                        //  }
                      })
                      }
                     
                    })
            },
    
            formatSelectedFiles(files:any) {
              if (files.length === 0) {
                return 'No files choosen';
              } else if (files.length === 1) {
                return files[0].name; // Display the name of the single chosen file
              } else {
                return files.map((x:any) => x.name).join(', \n'); // Indicate the number of chosen files
              }
            },
            addNewGroupDynamicFields(questions:any, questionGroupID:any){
            
             
              this.intakeForm.QuestionGroup.forEach((questionGroup:any) => {
            
                if(questionGroup.Name !== questionGroupID) return
              if(questionGroup.BranchingOptionsDynamics?.length > 1){
                      
              if(this.groupDynamicFieldCounter[questionGroupID] == null){
                this.groupDynamicFieldCounter[questionGroupID] = { counter : 2};
              }else{
                this.groupDynamicFieldCounter[questionGroupID].counter += 1;
              }     
                var counter = this.groupDynamicFieldCounter[questionGroupID].counter;
                  //questionGroupID = questionGroup.ID;
                
                  questions.forEach((question: any, index:any) => {
                    var newQuestion:any = {...question.Question};
                    newQuestion.Caption = newQuestion.Caption + ' ' + counter;
                    newQuestion.ID = newQuestion.ID + '>' + counter;
                    newQuestion.SortOrder += ((counter - 1) * 4);
                    newQuestion.ControlID = questionGroup.Questions[index].ControlID + '>' + counter;
                    newQuestion.QuestionGroup = questionGroup.Name;
                    questionGroup.Questions.push(newQuestion);

                  
                
                  })
                  
                  
              }
              
             
              })

            
              if(this.groupHeaderDynamicFieldCounter[questionGroupID] === undefined){
                  this.groupHeaderDynamicFieldCounter[questionGroupID] = 1;
              }else{
                this.groupHeaderDynamicFieldCounter[questionGroupID] += 1;
              }

              this.hideBranchingQuestions();
               
            },
              removeNewGroupDynamicFields(questionGroup:any, overrideColumnDivider:any){
                if(questionGroup.Questions.length > overrideColumnDivider) 
                var removedQuestions = questionGroup.Questions.splice((-1 * overrideColumnDivider) - (questionGroup.Questions.length % overrideColumnDivider), overrideColumnDivider)
              
                
                removedQuestions.forEach((q:any) => {
                  Vue.set(this.questions,q.Caption.trim().replace(/\s/g, '-').replace(':','') + '+' + questionGroup.Name + '-' + questionGroup.SubTitle + '+' + q.ControlID, '')
                })
                if(this.groupDynamicFieldCounter[questionGroup.Name].counter >= 2){
                   this.groupDynamicFieldCounter[questionGroup.Name].counter -= 1;
                }

                

              },
              onReset(e:any){
                
                const resetConfirm = confirm('Pressing reset button will clear all information entered on form, do you want to proceed?');


                if(!resetConfirm){
                  e.preventDefault();
                  return;
                }

                Object.keys(this.questions).forEach((key:any) => {
                  const currentQuestion = this.questions[key];
                  if(currentQuestion){
                    Vue.set(this.questions, key, '')
                  }
                })

                this.$refs.filesRef.forEach((file:any) => {
                 
                  file.removeFiles();
                });

              },
              onInvalidSubmit(props:any) {
                
                console.log(props.values); 
                console.log(props.errors); 
                console.log(props.results);
              },
              addTag(newTag:any, index:any){

             

                let modelKey = '';
                this.$refs.questionRefs.forEach((el:any) =>{ 
                 
                    const parent = el.children[1]?.children[0];
                    const inputEl = el.children[1]?.children[0].querySelector('input');
                   
                    if(parent && inputEl?.id == index){
                      modelKey = parent.getAttribute('modelkey')
                    }
                });

                 var newObject = {
                  value: newTag + '|' + index + '|' + (this.questionOptions[index].length - 1 + 1),
                  text : newTag,
                  label:newTag
                  }


          
                if(this.questionOptions[index] && modelKey){

                    
                    this.questionOptions[index].push(newObject);

                    var currentModelValue = this.questions[modelKey];
                    currentModelValue.push(newObject);
                    Vue.set(this.questions, modelKey, currentModelValue);
                    
                    //this.questions[modelKey].push(newObject);
                }

                  
          
              },
              setLocalizationDropdownValue(localization:any, val:any ,localizationObject:any){
                    var localizationCode = '';
                    var localizationDisplay = '';
                  
                   if(localization.length == 3){
                        localizationCode = localization[0] + '-' + localization[1];
                        localizationDisplay = localization[2];
                        if(! this.languageLocalizations.some((x:any) => x.value == localizationCode)){
                            this.languageLocalizations.push({value:localizationCode, text:localizationDisplay});
                        }
                   
                         i18n.setLocaleMessage(localizationCode, localizationObject[val]);
                    }else if(localization.length == 2){
                        localizationCode = localization[0] + '-' + localization[1];
                        localizationDisplay = localization[1];
                        if(! this.languageLocalizations.some((x:any) => x.value == localizationCode)){
                            this.languageLocalizations.push({value:localizationCode, text:localizationDisplay});
                        }
                         i18n.setLocaleMessage(localizationCode, localizationObject[val]);
                    }
                    else{
                      this.languageLocalizations.push({value:val, text:val});
                    }

                    Object.keys(localizationObject[val]).forEach((x:any) => {
                    
                      if(x.includes('-HelpText')){
                      
                        this.intakeForm.HelpTextLocalizations.push(x);
                      }
                    })
                     
                  
					
              },
              calculateFieldFormula(value:any, question:any, questionGroup:any){
                
                var valueSplit = value.split('<>');
                var originalValue = parseInt(valueSplit[0]);
                var parentControlId = valueSplit[1];
                var currentControlParent = this.questionFormulas.filter((x:any) => x.ParentID == parentControlId.toString());
                var currentFormula = currentControlParent.length > 0 ? currentControlParent[0].Formula : '';
                
                if(currentFormula === '') return;
                this.questionFormulaIDCache[question.ControlID] = originalValue;
                const regex = /{(.*?)}/g;
                const matches = currentFormula.matchAll(regex);
                const matchesValues = Array.from(matches, (match:any) => match[1]);
                
                matchesValues.forEach((x:any) => {
                  if(x === question.ControlID){
                      currentFormula = currentFormula.replace('{' + x + '}',  this.questionFormulaIDCache[question.ControlID]);
                  }else{
                    if(this.questionFormulaIDCache[x]){
                      currentFormula = currentFormula.replace('{' + x + '}',  this.questionFormulaIDCache[x]);
                    }
                  }
                
                })

                let formulaCalculated = 0;
                try {
                  formulaCalculated = eval(currentFormula); 
                } catch (e) {
                  if (e instanceof SyntaxError) {
                    console.log(e.message);
                  }
                }
         

                formulaCalculated = parseFloat(formulaCalculated.toFixed(2));
                //find parent
                this.$refs.questionRefs.forEach((el:any) => {
                  var controlid = el.children[1].firstElementChild.getAttribute('controlid');
                
                  if(controlid && controlid == currentControlParent[0].ParentID){
                      //update the value
                    
                      var qGroupIndex = this.intakeForm.QuestionGroup.indexOf(questionGroup);
                      var targetQuestion = this.intakeForm.QuestionGroup[qGroupIndex].Questions.filter((x:any) => x.ControlID === controlid)[0];
               
                      Vue.set(this.questions, targetQuestion.Caption.trim().replace(/\s/g, '-').replace(':','') + '+' + questionGroup.Name + '-' + questionGroup.SubTitle + '+' + targetQuestion.ControlID, formulaCalculated)
                      return;
                  }
                });
              },
             
             
          }
          
          
        })
        
        